import { useBindProp as o } from "../props.js";
import { setValueOrSetOption as r } from "../../utils/options.js";

function t(t, s) {
  o(t, {
    setter: function setter(o, t) {
      r(o, "cursor", "setCursor", t);
    }
  }, s.cursor);
}

export default t;